import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  FormControlLabel,
  Switch
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const DutyTimeFDPRules = ({ baseline, handleChange }) => {
  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Duty Time / FDP Rules</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Max Daily FDP Hours"
              type="number"
              value={baseline.maxDailyFDPHours}
              onChange={(e) => handleChange('maxDailyFDPHours', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 24, step: 0.5 }}
              helperText="Maximum daily Flight Duty Period hours (CAR Section 7, Series J)"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Approach Warning Threshold Hours"
              type="number"
              value={baseline.approachWarningThresholdHours}
              onChange={(e) => handleChange('approachWarningThresholdHours', parseFloat(e.target.value))}
              inputProps={{ min: 0, max: 24, step: 0.5 }}
              helperText="Warning threshold before FDP limit"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={baseline.allowExtensions}
                  onChange={(e) => handleChange('allowExtensions', e.target.checked)}
                />
              }
              label="Allow FDP Extensions (CAR Section 7, Series J, Part III)"
            />
          </Grid>
          {baseline.allowExtensions && (
            <>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Max FDP Extension Hours"
                  type="number"
                  value={baseline.maxFdpExtensionHours}
                  onChange={(e) => handleChange('maxFdpExtensionHours', parseFloat(e.target.value))}
                  inputProps={{ min: 0, max: 4, step: 0.5 }}
                  helperText="Maximum FDP extension under Part III"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Max Flight Time Extension Hours"
                  type="number"
                  value={baseline.maxFlightTimeExtensionHours}
                  onChange={(e) => handleChange('maxFlightTimeExtensionHours', parseFloat(e.target.value))}
                  inputProps={{ min: 0, max: 2, step: 0.5 }}
                  helperText="Maximum flight time extension under Part III"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Rest Compensation for 1h Extension"
                  type="number"
                  value={baseline.restCompForExtension1h}
                  onChange={(e) => handleChange('restCompForExtension1h', parseFloat(e.target.value))}
                  inputProps={{ min: 0, step: 0.5 }}
                  helperText="Additional rest hours for 1h extension"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Rest Compensation for 2h Extension"
                  type="number"
                  value={baseline.restCompForExtension2h}
                  onChange={(e) => handleChange('restCompForExtension2h', parseFloat(e.target.value))}
                  inputProps={{ min: 0, step: 0.5 }}
                  helperText="Additional rest hours for 2h extension"
                />
              </Grid>
            </>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default DutyTimeFDPRules;
